import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';

export function useFormat() {
  const { formatMessage } = useIntl();
  function formatDateLabel(
    message: MessageDescriptor,
    date: string | null | undefined
  ) {
    if (!date) {
      return '';
    }
    return `${formatMessage(message)}: ${date}`;
  }
  return { formatDateLabel };
}
